import React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import { useQuery } from 'react-query';
import { ImageType } from '@types';
import { queryKeys } from '@queryClient';
import Image from '@components/Image';
import IconTrash from '@components/icons/IconTrash';
import ImgArticle from './img-article.png';
import { fetchArticleItem } from '../../../mediaLib';

interface Props {
  id: number;
  listIndex: number;
  onDelete: (index: number) => void;
}

function CArticleItem({ id, listIndex, onDelete }: Props) {
  const { data } = useQuery(
    [queryKeys.libItemArticle, id],
    () => fetchArticleItem(id),
    {
      retry: 0,
      onError: () => {
        onDelete(listIndex);
      },
    }
  );

  return (
    <div className="relative mb-10 flex h-35 select-none items-center rounded bg-black-border px-10">
      {!!data && (
        <>
          <Image
            src={data.thumb || ImgArticle}
            size={16}
            type={data.thumb ? ImageType.thumb : undefined}
            className="h-16 w-16 bg-black"
          />
          <div className="mx-5 flex-grow truncate text-base text-white">
            {data.title}
          </div>
          <IconTrash
            className="flex-shrink-0"
            onClick={() => onDelete(listIndex)}
          />
        </>
      )}
    </div>
  );
}

export default SortableElement(CArticleItem);
